module.exports = __webpack_public_path__ + "static/media/Admin-5.3aed130b.png";